import { useMoveToWebview } from './moveToWebview';
import { moveToToday } from './moveToToday';
import { moveToSearch } from './moveToSearch';
import { useMoveToScreens } from './moveToScreens';
import { useMoveToHome } from './moveToHome';
import { useMoveToLikeFolders } from './moveToLikeFolders';
import { moveToRoot } from './moveToRoot';

export const useCommonNavigator = () => {
  const moveToWebview = useMoveToWebview();
  const moveToScreens = useMoveToScreens();
  const moveToHome = useMoveToHome();
  const moveToLikeFolders = useMoveToLikeFolders();

  return {
    moveToRoot,
    moveToWebview,
    moveToToday,
    moveToSearch,
    moveToScreens,
    moveToHome,
    moveToLikeFolders,
  };
};
